<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <vx-card class="list-view-item overflow-hidden" v-on="$listeners">
    <template slot="no-body">
      <div class="item-details no-gutter">
        <b-row>
          <b-col lg="2" sm="6" md="2" xl="2">
            <div
              class="
                w-full
                item-img-container
                bg-white
                flex
                items-center
                justify-center
                cursor-pointer
              "
            >
              <img
              @error="errorImage"
                v-if="varyantlimi == 'true'"
                :src="sistemurl + item.image"
                :alt="item.stockName"
                class="grid-view-img"
                style="max-height: 90px"
                @click="
                  $router
                    .push({
                      name: 'ecommerce-item-detail-view',
                      params: { item_id: item.stockNo },
                    })
                    .catch(() => {})
                "
              />
              <img
              @error="errorImage"
                v-else
                :src="sistemurl + item.image"
                :alt="item.stockName"
                class="grid-view-img"
                style="max-height: 90px"
                @click="
                  $router
                    .push({
                      name: 'ecommerce-item-detail-view',
                      params: { item_id: item.barcode },
                    })
                    .catch(() => {})
                "
              />
            </div>
          </b-col> 
          <b-col lg="8" sm="6" md="8" xl="8">
            <div class="">
              <div class="p-4 pt-6">
                <slot name="item-meta">
                  <h6
                    v-if="varyantlimi == 'true'"
                    class="
                      item-name
                      font-semibold
                      mb-1
                      hover:text-primary
                      cursor-pointer
                    "
                    @click="
                      $router
                        .push({
                          name: 'ecommerce-item-detail-view',
                          params: { item_id: item.stockNo },
                        })
                        .catch(() => {})
                    "
                  >
                  {{ item }}
                  {{item.stockNo}}
                    {{ item.stockName }}
                  </h6>
                  <h6
                    v-else
                    class="
                      item-name
                      font-semibold
                      mb-1
                      hover:text-primary
                      cursor-pointer
                    "
                    @click="
                      $router
                        .push({
                          name: 'ecommerce-item-detail-view',
                          params: { item_id: item.barcode },
                        })
                        .catch(() => {})
                    "
                  >
                    {{ item.stockName }}
                  </h6>
                </slot>
              </div>
            </div>
          </b-col>
          <b-col lg="2" sm="6" md="2" xl="2">
            <div
              class="
                w-full
                flex
                items-center
                border-0 border-solid
                d-theme-border-grey-light
                border-r-0 border-t-0 border-b-0
              "
            >
              <div class="p-2 flex flex-col w-full">
                <!--   <div class="my-6">
              <h5 class="font-bold text-center">{{ item.FIYAT }} TL</h5>
              
            </div>

             SLOT: ACTION BUTTONS -->
                <slot name="action-buttons" />
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- IMG COL -->

        <!-- ITEM NAME & DESC COL -->

        <!-- PURCHASE COL -->
      </div>
    </template>
  </vx-card>
</template>


<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import userJson from "../../../../../public/user.json";
export default {
  data() {
    return {
      varyantlimi: userJson.varyant,
      sistemurl: "",
    };
  },
  created() {
    this.sistemurl = userJson.resimUrl;
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isInCart() {
      return (itemId) => this.$store.getters["eCommerce/isInCart"](itemId);
    },
    isInWishList() {
      return (itemId) => this.$store.getters["eCommerce/isInWishList"](itemId);
    },
  },
  methods: {
    errorImage(e){ 
      if(e.type == "error") e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg" 
    },
    toggleItemInWishList(item) {
      this.$store.dispatch("eCommerce/toggleItemInWishList", item);
    },
    additemInCart(item) {
      this.$store.dispatch("eCommerce/additemInCart", item);
    },
    cartButtonClicked(item) {
      this.isInCart(item.BARCODE)
        ? this.$router.push("/products/checkout").catch(() => {})
        : this.additemInCart(item);
    },
    navigate_to_detail_view() {
      this.$router
        .push({
          name: "ecommerce-item-detail-view",
          params: { item_id: this.item.BARCODE },
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
